import React from 'react';
import Icon from '@material-ui/core/Icon'
import classes from './JIcon.module.scss'

const JIcon = (props) => {
    let iconElement = null;

    switch (props.icontype) {
        case ('link_to_top'):
            iconElement = <Icon className={classes.LinkToTop} {...props}>arrow_circle_up</Icon>
            break;
        default:
            iconElement = <Icon className={classes.LinkToTop} {...props}>add_plus</Icon>
    }
    return (
        <div>{iconElement}</div>
    );
}

export default JIcon;